import HtmlRenderer from './HtmlRenderer';

export default HtmlRenderer;
